<script>
  import Button from './Button.svelte';
  import NamePrompt from './NamePrompt.svelte';
  import Notebook from './Notebook.svelte';
  import WaitingFor from './WaitingFor.svelte';

  export let notebooksList;

  let names;
  let notebookType;
  let selection;

  const getNotebooksNames = async () => {
    names = await notebooksList.list();
    // console.log(names, selection)
    if (!Object.keys(names || {}).includes(selection)){
      selection = Object.keys(names)[0];
    }
    notebookType = await notebooksList.notebook_type;
  }
  
</script>

{#await getNotebooksNames()}
  <WaitingFor />
{:then _} 
  <div class='tabs-container'>
    {#each Object.entries(names) as [notebookId, name]}
      {#if selection != notebookId}
        <Button on:click={() => {selection = notebookId}} style="margin: 0;border: none; border-bottom: solid 0.5px var(--tertiary);">{name}</Button>
      {:else}
        <NamePrompt name={'✎ ' + name } style="margin: 0; border: none; color: var(--primary); border-bottom: solid 0.5px var(--primary);"
        originalChildName='Untitled'
        on:submit={async ({detail}) => {
          // console.log(detail)
          await notebooksList.get(selection).rename(detail)
          names = await notebooksList.list();  
        }} />
      {/if}

    {/each}
    <NamePrompt name="+ {notebookType}" style="background-color: transparent; color: var(--secondary); border: solid 0.5px var(--secondary);" on:submit={async ({detail}) => {
      selection = await notebooksList.create(detail).notebook_id
      names = await notebooksList.list();  
    }} />
  </div>
{/await}
{#if selection}
  {#await notebooksList.get(selection)._timeout(10)}
    <WaitingFor />
  {:then notebook}
    <Notebook notebook={notebook} on:update={getNotebooksNames}/>
  {/await}
{:else}
  <slot />
{/if}

<style>
  .tabs-container {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 4px;
  }
</style>